import { render, staticRenderFns } from "./QuizFriends.vue?vue&type=template&id=4e3cd73c&scoped=true&"
import script from "./QuizFriends.vue?vue&type=script&lang=js&"
export * from "./QuizFriends.vue?vue&type=script&lang=js&"
import style0 from "./QuizFriends.vue?vue&type=style&index=0&id=4e3cd73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3cd73c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
